module.exports = __webpack_public_path__ + "img/profile.a43d6cb0.jpg";